export default __webpack_public_path__ + "./images/ve.0bc29937.png";